(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const fields = [...root.querySelectorAll('[data-filter]')];
    const cards = [...root.querySelectorAll('[data-oil-product]')];
    const update = () => {
      let visible = 0;
      cards.forEach(card => {
        const match = fields.every(field => !field.value || card.dataset[field.dataset.filter] === field.value);
        card.hidden = !match;
        if (match) visible++;
      });
      root.querySelector('[data-result-count]').textContent = `条件に一致する掲載商品：${visible}件`;
      root.querySelector('[data-empty]').hidden = visible > 0;
    };
    fields.forEach(field => field.addEventListener('change', update));
    root.querySelectorAll('[data-grade]').forEach(button => button.addEventListener('click', () => {
      const [cold, hot] = button.dataset.grade.split('-');
      root.querySelector('[data-grade-cold]').textContent = cold;
      root.querySelector('[data-grade-hot]').textContent = hot;
      root.querySelectorAll('[data-grade]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    }));
    update();
  }
  document.querySelectorAll('[data-k1-guide]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-k1-guide]').forEach(init));
})();
